// A YouTube link someone pasted into a free tool page (/tools/...) before signing up: kept in
// localStorage, then put into the /workspace composer once they're in, with a hint for that tool.
const KEY = 'pendingYoutubeLink';
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

export const TOOL_HINTS = {
  timestamps: 'Click Start. Your timestamps appear next to the video, ready to copy into YouTube.',
  transcript: 'Click Start. When it’s ready, open Export and choose Transcript or Subtitles.',
  summary: 'Click Start, then ask “Summarize the video” in the chat next to it.',
};

export function savePendingLink(url, tool) {
  try { localStorage.setItem(KEY, JSON.stringify({ url, tool, at: Date.now() })); } catch { /* storage off */ }
}

// The pending link (once), or null if there is none or it's over a day old
export function takePendingLink(now = Date.now()) {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    localStorage.removeItem(KEY);
    const p = JSON.parse(raw);
    return p && p.url && now - p.at < MAX_AGE_MS ? p : null;
  } catch {
    return null;
  }
}
